export const InvestorRegistrationStep = {
	NotStarted: 0,
	AbsherVerification: 1,
	PersonalInformation: 2,
	DocumentVerification: 3,
	Declaration: 4,
};
